import { render, staticRenderFns } from "./create.vue?vue&type=template&id=8f129e2e&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=8f129e2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f129e2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f129e2e')) {
      api.createRecord('8f129e2e', component.options)
    } else {
      api.reload('8f129e2e', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=8f129e2e&scoped=true", function () {
      api.rerender('8f129e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recruitment/create.vue"
export default component.exports